(function () {
  'use strict';
  function boot() {
    var dataNode = document.getElementById('outletlet-japan-locale');
    if (!dataNode || window.__outletletJapanLocale) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    if (data.locale !== 'ja') return;
    window.__outletletJapanLocale = true;
    var normalize = function (value) { return String(value || '').replace(/\s+/g, ' ').trim(); };
    var textMap = new Map(data.pairs.map(function (pair) { return [normalize(pair[0]), pair[1]]; }));
    var pageRoot = document.querySelector('.__pf');
    var isMirror = data.story === true || /\/pages\/digital-rearview-mirror\/?$/.test(location.pathname);
    var isContact = /\/pages\/contact\/?$/.test(location.pathname);
    var skip = 'script,style,noscript,textarea,input,select,option,[contenteditable="true"],#looxReviews,.loox-review,[data-loox-review]';
    var policyTemplate = document.getElementById('outletlet-japan-policy-preview');
    var policyBody = document.querySelector('.shopify-policy__body');
    if (policyTemplate && policyBody) policyBody.replaceChildren(policyTemplate.content.cloneNode(true));
    function translateText(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!node.parentElement || node.parentElement.closest(skip)) return;
        var value = normalize(node.nodeValue);
        if (/^Go to slide \d+$/.test(value)) node.nodeValue = 'スライド' + value.match(/\d+$/)[0] + 'を表示';
        if (isMirror && /^\d+% OFF$/.test(value)) node.nodeValue = value.replace('% OFF', '%割引');
        if (isContact) {
          var labels = {ADDRESS:'所在地', EMAIL:'メール', PHONE:'電話', 'FOLLOW US':'公式SNS'};
          Object.keys(labels).forEach(function (label) {
            if (value.toUpperCase() === label || value.toUpperCase().indexOf(label + ' ') === 0) node.nodeValue = node.nodeValue.replace(new RegExp(label, 'i'), labels[label]);
          });
        }
        if (textMap.has(value)) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), textMap.get(value));
      });
      root.querySelectorAll('[aria-label],img[alt],[title],[placeholder]').forEach(function (el) {
        if (el.closest('script,style,noscript,#looxReviews,.loox-review,[data-loox-review]')) return;
        ['aria-label', 'alt', 'title', 'placeholder'].forEach(function (attr) {
          var value = el.getAttribute(attr);
          if (value && attr === 'aria-label' && value.endsWith('の数量') && textMap.has(normalize(value.slice(0, -3)))) el.setAttribute(attr, textMap.get(normalize(value.slice(0, -3))) + 'の数量');
          else if (value && textMap.has(normalize(value))) el.setAttribute(attr, textMap.get(normalize(value)));
          else if (value && /^Go to slide \d+$/.test(value)) el.setAttribute(attr, 'スライド' + value.match(/\d+$/)[0] + 'を表示');
          else if (value && /^View mirror product image \d+$/.test(value)) el.setAttribute(attr, '商品画像' + value.match(/\d+$/)[0] + 'を見る');
          else if (value && /^Product gallery control \d+$/.test(value)) el.setAttribute(attr, '商品画像の表示切り替え ' + value.match(/\d+$/)[0]);
          else if (value && /^OUTLETLET 4K Digital Rearview Mirror product view \d+$/.test(value)) el.setAttribute(attr, 'OUTLETLET デジタルルームミラー 商品画像' + value.match(/\d+$/)[0]);
        });
      });
    }
    function replaceImages() {
      if (!isMirror || !pageRoot) return;
      var paymentTemplate = document.getElementById('outletlet-japan-payment-methods');
      if (paymentTemplate) pageRoot.querySelectorAll('img[src*="dddd1-1682842570353"]').forEach(function (img) { img.replaceWith(paymentTemplate.content.cloneNode(true)); });
      pageRoot.querySelectorAll('img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        var asset = data.images.find(function (item) { return src.indexOf('/' + item.source) !== -1 || src.split('?')[0] === item.url.split('?')[0]; });
        if (!asset) return;
        if (img.getAttribute('src') !== asset.url) img.src = asset.url;
        ['srcset', 'data-srcset', 'data-src', 'data-lazy-src', 'data-lazy-srcset'].forEach(function (attr) { img.removeAttribute(attr); });
        img.alt = asset.alt;
        var picture = img.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach(function (source) { source.srcset = asset.url; });
      });
      pageRoot.querySelectorAll('[data-image],a[href]').forEach(function (el) {
        ['data-image', 'href'].forEach(function (attr) {
          var value = el.getAttribute(attr) || '';
          var asset = data.images.find(function (item) { return value.indexOf('/' + item.source) !== -1; });
          if (asset) el.setAttribute(attr, asset.url);
        });
      });
    }
    function localizeLinks() {
      document.querySelectorAll('a[href]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#' || /^(mailto:|tel:)/.test(href)) return;
        var url;
        try { url = new URL(href, location.origin); } catch (error) { return; }
        if (url.origin !== location.origin) return;
        if (decodeURIComponent(url.pathname).indexOf('”') !== -1 && decodeURIComponent(url.pathname).indexOf('/policies/shipping-policy') !== -1) {
          link.setAttribute('href', data.root.replace(/\/$/, '') + '/policies/shipping-policy');
          return;
        }
        if (/^\/(policies|pages|blogs|products|collections|cart|search)(\/|$)/.test(url.pathname)) {
          url.pathname = data.root.replace(/\/$/, '') + url.pathname;
          link.setAttribute('href', url.pathname + url.search + url.hash);
        }
      });
    }
    function metadata() {
      if (!isMirror) return;
      if (document.title !== data.title) document.title = data.title;
      ['meta[name="description"]', 'meta[property="og:description"]'].forEach(function (selector) {
        var el = document.querySelector(selector);
        if (el && el.content !== data.description) el.content = data.description;
      });
      var hero = data.images.find(function (item) { return item.source === 'mirror-hero-desktop.webp'; });
      if (hero) document.querySelectorAll('meta[property="og:image"],meta[property="og:image:secure_url"],meta[name="twitter:image"]').forEach(function (el) { if (el.content !== hero.url) el.content = hero.url; });
      var schema = document.getElementById('outletlet-product-schema');
      if (schema) {
        try {
          var value = JSON.parse(schema.textContent);
          if (value.name !== data.productTitle) {
            value.name = data.productTitle;
            value.description = data.description;
            if (hero) value.image = [hero.url].concat((value.image || []).slice(1));
            schema.textContent = JSON.stringify(value);
          }
        } catch (error) { }
      }
    }
    function placeSupportAfterReviews() {
      if (!isMirror || data.country !== 'JP' || !pageRoot || pageRoot.querySelector('#ol-jp-v2')) return;
      var support = pageRoot.querySelector('[data-section-id="pf-6f9c"]');
      var reviews = pageRoot.querySelector('[data-section-id="pf-fca1"]');
      if (!support || !reviews || support.parentElement !== reviews.parentElement) return;
      if (reviews.nextElementSibling !== support) reviews.parentElement.insertBefore(support, reviews.nextSibling);
    }

    function arrangeJapanStory() {
      if (!isMirror || data.country !== 'JP' || !data.story || !pageRoot) return;
      var existing = pageRoot.querySelector('#ol-jp-v2');
      if (existing) return;
      var template = document.getElementById('outletlet-japan-story-template');
      var story = template && template.content && template.content.querySelector('#ol-jp-v2');
      var purchase = pageRoot.querySelector('[data-section-id="pf-05c9"]');
      var reviews = pageRoot.querySelector('[data-section-id="pf-fca1"]');
      if (!story || !purchase || !reviews) return;
      var parent = purchase.parentElement;
      if (!parent || reviews.parentElement !== parent || parent.closest('#ol-jp-v2')) return;
      var next = story.cloneNode(true);
      var purchaseSlot = next.querySelector('[data-jp-v2-purchase-slot]');
      var reviewSlot = next.querySelector('[data-jp-v2-review-slot]');
      if (!purchaseSlot || !reviewSlot || purchaseSlot === reviewSlot ||
          purchaseSlot.contains(reviewSlot) || reviewSlot.contains(purchaseSlot)) return;
      var originalSections = Array.prototype.filter.call(parent.children, function (element) {
        return element.hasAttribute('data-section-id');
      });
      if (originalSections.indexOf(purchase) === -1 || originalSections.indexOf(reviews) === -1) return;
      // Move the original widgets intact: event handlers, selected variants, and Loox source stay attached.
      parent.insertBefore(next, originalSections[0]);
      purchaseSlot.appendChild(purchase);
      reviewSlot.appendChild(reviews);
      originalSections.forEach(function (section) {
        // The original floating purchase link stays outside the narrative.
        if (section === purchase || section === reviews || section.getAttribute('data-section-id') === 'pf-359a') return;
        section.setAttribute('data-jp-v2-replaced', '');
        section.hidden = true;
        section.setAttribute('aria-hidden', 'true');
        section.style.setProperty('display', 'none', 'important');
      });
      var packageImage = purchase.querySelector('.sku-thumb img');
      var galleryImage = purchase.querySelector('#lux-main-image');
      if (packageImage && galleryImage && packageImage.getAttribute('src')) {
        galleryImage.src = packageImage.getAttribute('src');
        galleryImage.alt = packageImage.alt;
        galleryImage.removeAttribute('srcset');
        purchase.querySelectorAll('#lux-thumb-strip .is-active').forEach(function (thumb) { thumb.classList.remove('is-active'); });
      }
      var floating = document.getElementById('floating-bar');
      var floatingTemplate = next.querySelector('[data-jp-v2-floating-template]');
      if (floating && floatingTemplate && !floating.querySelector('.ol-v2-live-price')) {
        floating.insertBefore(floatingTemplate.content.cloneNode(true), floating.firstChild);
      }
      pageRoot.setAttribute('data-jp-story', '20261004-v2');
    }
    function markJapanStoryReady() {
      if (!isMirror || data.country !== 'JP' || !data.story || !pageRoot) return;
      var story = pageRoot.querySelector('#ol-jp-v2');
      var button = story && story.querySelector('#bundle-buy-button');
      // The page loader may reveal the narrative only after the original purchase control is localized.
      if (story && button && /[\u3040-\u30ff\u3400-\u9fff]/.test(button.textContent)) {
        var fallbackTitle = document.getElementById('outletlet-primary-title');
        if (fallbackTitle && story.querySelector('h1') && !story.contains(fallbackTitle)) fallbackTitle.remove();
        if (story.getAttribute('data-jp-v2-ready') !== 'true') story.setAttribute('data-jp-v2-ready', 'true');
      } else if (story && story.hasAttribute('data-jp-v2-ready')) story.removeAttribute('data-jp-v2-ready');
    }
    function parseYenPrice(value) {
      var match = String(value || '').trim().match(/^(?:JPY|\u00a5|\uffe5)\s*(\d{1,3}(?:,\d{3})+|\d+)$/);
      if (!match) return null;
      var amount = Number(match[1].replace(/,/g, ''));
      return Number.isSafeInteger(amount) ? amount : null;
    }
    function getPromotionSavings(nowText, oldText) {
      var now = parseYenPrice(nowText);
      var old = parseYenPrice(oldText);
      if (now === null || old === null || now <= 0 || old <= now) return null;
      return { amount: old - now, percent: Math.floor((old - now) * 100 / old) };
    }
    var promotionPriceLabels = new WeakMap();
    function setPromotionAttribute(element, name, value) {
      if (value === null) {
        if (element.hasAttribute(name)) element.removeAttribute(name);
      } else if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    }
    function setPromotionText(element, value) {
      if (element.textContent !== value) element.textContent = value;
    }
    function setPromotionHidden(element, hidden) {
      if (element.hidden !== hidden) element.hidden = hidden;
    }
    function visiblePrice(element) {
      if (!element || element.hidden || element.closest('[hidden]')) return false;
      var style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' && element.getClientRects().length > 0;
    }
    function renderPromotion() {
      if (data.country !== 'JP' || !isMirror) return;
      var area = document.getElementById('lux-bundle-area');
      var selected = area && area.querySelector('.bundle-item.selected');
      var now = selected && selected.querySelector('.bundle-price-now');
      var old = selected && selected.querySelector('.bundle-price-old');
      var button = document.getElementById('bundle-buy-button');
      var ready = button && !button.disabled && button.getAttribute('aria-busy') === 'false' && button.getAttribute('aria-disabled') !== 'true' && !button.classList.contains('is-loading');
      var current = data.currency === 'JPY' && ready && visiblePrice(now) ? parseYenPrice(now.textContent) : null;
      if (current !== null && current <= 0) current = null;
      var savings = current !== null && visiblePrice(old) ? getPromotionSavings(now.textContent, old.textContent) : null;
      var formatYen = function (amount) {
        return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(amount).replace('\uffe5', '\u00a5');
      };
      if (current !== null) setPromotionText(now, formatYen(current));
      if (savings) setPromotionText(old, formatYen(parseYenPrice(old.textContent)));
      var story = pageRoot && pageRoot.querySelector('#ol-jp-v2');
      if (story) {
        // Empty and hide stale prices while the original market/variant request is pending or unavailable.
        var values = {
          current: current === null ? '' : formatYen(current),
          compare: savings ? formatYen(parseYenPrice(old.textContent)) : '',
          saving: savings ? formatYen(savings.amount) : '',
          percent: savings && savings.percent > 0 ? '約' + savings.percent + '% OFF' : ''
        };
        document.querySelectorAll('#ol-jp-v2 [data-jp-v2-price], #floating-bar [data-jp-v2-price]').forEach(function (element) {
          var key = element.getAttribute('data-jp-v2-price');
          if (!Object.prototype.hasOwnProperty.call(values, key)) return;
          setPromotionText(element, values[key]);
          if (key === 'percent') setPromotionHidden(element, !values.percent);
        });
        document.querySelectorAll('#ol-jp-v2 [data-jp-v2-price-group], #floating-bar [data-jp-v2-price-group]').forEach(function (element) { setPromotionHidden(element, current === null); });
        story.querySelectorAll('[data-jp-v2-compare-group],[data-jp-v2-saving-group]').forEach(function (element) { setPromotionHidden(element, !savings); });
      }
      if (!area) return;
      var wrapper = area.querySelector('.bundle-title-wrapper');
      var title = wrapper && wrapper.querySelector('.bundle-title-text');
      if (!title) return;
      var promotion = data.promotion;
      var labelsReady = promotion && typeof promotion.saving === 'string' && promotion.saving.indexOf('{amount}') !== -1 && typeof promotion.comparison === 'string' && promotion.comparison.length > 0 && typeof promotion.price === 'string' && promotion.price.length > 0;
      var showSavings = savings && labelsReady;
      area.querySelectorAll('.bundle-price-old[data-jp-compare]').forEach(function (element) {
        if (showSavings && element === old) return;
        setPromotionAttribute(element, 'data-jp-compare', null);
        if (promotionPriceLabels.has(element)) {
          setPromotionAttribute(element, 'aria-label', promotionPriceLabels.get(element));
          promotionPriceLabels.delete(element);
        }
      });
      var saving = title.querySelector('[data-jp-promo-saving]');
      var note = title.querySelector('[data-jp-promo-note]');
      setPromotionAttribute(wrapper, 'data-jp-sale', showSavings ? 'true' : null);
      if (!showSavings) {
        if (saving) setPromotionHidden(saving, true);
        if (note) setPromotionHidden(note, true);
        return;
      }
      if (!saving) {
        saving = document.createElement('span');
        saving.setAttribute('data-jp-promo-saving', '');
        title.appendChild(saving);
      }
      if (!note) {
        note = document.createElement('span');
        note.setAttribute('data-jp-promo-note', '');
        title.appendChild(note);
      }
      setPromotionText(saving, promotion.saving.replace('{amount}', formatYen(savings.amount)));
      setPromotionText(note, promotion.comparison);
      setPromotionHidden(saving, false);
      setPromotionHidden(note, false);
      if (!promotionPriceLabels.has(old)) promotionPriceLabels.set(old, old.getAttribute('aria-label'));
      setPromotionAttribute(old, 'data-jp-compare', promotion.price);
      setPromotionAttribute(old, 'aria-label', promotion.price + ' ' + normalize(old.textContent));
    }
    var queued = false;
    var observer;
    function apply() {
      queued = false;
      if (observer) observer.disconnect();
      if (isContact) {
        document.querySelectorAll('#MainContent h1,#MainContent h2').forEach(function (el) {
          if (/^(Contact Us|お問い合わせ Us)$/.test(normalize(el.textContent))) el.textContent = 'お問い合わせ';
        });
        document.querySelectorAll('#MainContent option').forEach(function (el) {
          if (textMap.has(normalize(el.textContent))) el.label = textMap.get(normalize(el.textContent));
        });
        document.querySelectorAll('#MainContent a').forEach(function (el) {
          if ((el.getAttribute('href') || '').indexOf('support@luxelull.com') !== -1) el.href = 'mailto:support@outletlet.com';
          if ((el.getAttribute('title') || '').indexOf('tel:+33') === 0) { el.href = 'tel:+17024838035'; el.title = '電話：+1 (702) 483-8035'; }
        });
      }
      arrangeJapanStory();
      placeSupportAfterReviews();
      translateText(document.body);
      replaceImages();
      localizeLinks();
      metadata();
      renderPromotion();
      markJapanStoryReady();
      var observedAttributes = ['src', 'srcset', 'alt', 'aria-label'];
      if (data.country === 'JP' && isMirror) observedAttributes = observedAttributes.concat(['class', 'hidden', 'disabled', 'aria-busy', 'aria-disabled']);
      if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: observedAttributes });
    }
    observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    });
    apply();
    window.addEventListener('load', apply, { once: true });
    setTimeout(apply, 1700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();




